var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gridlayout" },
    [
      _vm._l(_vm.numberOfRows, function (rowNumber, rowIndex) {
        return _c("div", [
          _c(
            "div",
            { staticClass: "gridlayout-row" },
            _vm._l(_vm.row(rowIndex), function (slide) {
              return _c(
                "div",
                { staticClass: "gridlayout-cell", style: _vm.cellStyles },
                [
                  _c("cropzoomImg", {
                    key: slide.title,
                    ref: "imgs",
                    refInFor: true,
                    attrs: {
                      src: slide.imageUrl,
                      title: slide.title,
                      alt: slide.alt,
                      "aspect-ratio": _vm.aspectRatio,
                      data: slide,
                      "click-callback": _vm.handleClick,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      }),
      _vm._v(" "),
      _vm.options.hasMoreUrl
        ? _c("div", { staticClass: "gridlayout-hasMoreUrl" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-primary btn-primary-ghost",
                attrs: { href: _vm.options.moreUrl },
              },
              [_vm._v("View More")]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }